import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.work.item');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-work-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.work.item/view.scss */
:host {
  display: block;
  min-height: 100%;
  overflow-x: hidden;
  background: #f7f8f8;
  color: #111111;
  --work-detail-border: #dddddd;
  --work-detail-divider: #ececec;
  --work-detail-muted: #707070;
  --work-detail-hover: #f5f5f4;
  --work-detail-ink: #111111;
}

:host ::ng-deep h1,
:host ::ng-deep h2,
:host ::ng-deep h3,
:host ::ng-deep p,
:host ::ng-deep span,
:host ::ng-deep dt,
:host ::ng-deep dd,
:host ::ng-deep button,
:host ::ng-deep a,
:host ::ng-deep select {
  overflow-wrap: anywhere;
  letter-spacing: 0;
}

:host ::ng-deep button,
:host ::ng-deep a,
:host ::ng-deep select {
  outline-offset: 2px;
}

:host ::ng-deep button:focus-visible,
:host ::ng-deep a:focus-visible,
:host ::ng-deep select:focus-visible {
  outline: 2px solid var(--work-detail-ink);
  outline-offset: 2px;
  box-shadow: none;
}

:host ::ng-deep select:focus {
  border-color: var(--work-detail-ink) !important;
  box-shadow: 0 0 0 2px rgba(17, 17, 17, 0.08) !important;
}

:host ::ng-deep [class~=border-zinc-100],
:host ::ng-deep [class~=border-zinc-200],
:host ::ng-deep [class~=border-zinc-300] {
  border-color: var(--work-detail-border) !important;
}

:host ::ng-deep [class~=divide-zinc-100] > :not([hidden]) ~ :not([hidden]) {
  border-color: var(--work-detail-divider) !important;
}

:host ::ng-deep [class~=text-zinc-500],
:host ::ng-deep [class~=text-zinc-400] {
  color: var(--work-detail-muted) !important;
}

:host ::ng-deep button:hover,
:host ::ng-deep a:hover {
  border-color: #cfcfcf !important;
}

:host ::ng-deep [class~="hover:bg-zinc-50"]:hover {
  background-color: var(--work-detail-hover) !important;
}

:host ::ng-deep [class~=bg-zinc-950] {
  background-color: var(--work-detail-ink) !important;
}

:host ::ng-deep [class~=shadow-sm],
:host ::ng-deep [class~=shadow] {
  box-shadow: none !important;
}

:host ::ng-deep .wr-detail-state {
  border: 1px dashed var(--work-detail-border);
  border-radius: 8px;
  background-color: transparent;
  padding: 18px;
  text-align: left;
}

:host ::ng-deep .wr-detail-state-title {
  margin: 0;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.45;
  color: #111111;
}

:host ::ng-deep .wr-detail-state-copy {
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.65;
  color: var(--work-detail-muted);
}

:host ::ng-deep .wr-detail-state-action {
  display: inline-flex;
  height: 30px;
  min-height: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--work-detail-border);
  border-radius: 6px;
  background-color: #ffffff;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 650;
  color: #3f3f3f;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;
}

:host ::ng-deep .wr-detail-state-action:hover {
  border-color: #c8c8c8 !important;
  background-color: var(--work-detail-hover) !important;
  color: #111111;
}

:host ::ng-deep .wr-detail-media-state {
  background-color: #f3f4f4;
}

:host ::ng-deep .wr-detail-title,
:host ::ng-deep .wr-detail-copy {
  overflow-wrap: anywhere;
}

@media (max-width: 640px) {
  :host ::ng-deep main,
  :host ::ng-deep article,
  :host ::ng-deep section,
  :host ::ng-deep aside,
  :host ::ng-deep div {
    min-width: 0;
    max-width: 100%;
  }
  :host ::ng-deep button,
  :host ::ng-deep a,
  :host ::ng-deep select {
    min-height: 44px;
  }
  :host ::ng-deep button,
  :host ::ng-deep a {
    min-width: 44px;
  }
  :host ::ng-deep img {
    max-width: 100%;
  }
}`],
})
export class PageWorkItemComponent implements OnInit, OnDestroy {
    public id: string = "";
    public item: any = null;
    public missing: boolean = false;
    public taskRows: any[] = [];
    public deletingItem: boolean = false;
    public statusOverrides: any = {};
    public quickItems: any[] = [];
    public mediaFailures: any = {};
    private localQuickProjects: any[] = [];

    public contentTypes: any[] = [
        { key: "project", label: "프로젝트" },
        { key: "work", label: "작업물" },
        { key: "reference", label: "참고자료" },
        { key: "output", label: "결과물" },
        { key: "note", label: "체크리스트/메모" },
    ];

    public kindFilters: any[] = [
        { key: "presentation", label: "발표자료" },
        { key: "proposal", label: "제안서" },
        { key: "document", label: "문서" },
        { key: "image", label: "이미지" },
        { key: "link", label: "링크" },
        { key: "memo", label: "메모" },
        { key: "etc", label: "기타" },
    ];

    public statusOptions: any[] = [
        { key: "초안", label: "초안" },
        { key: "진행 중", label: "진행 중" },
        { key: "검토 필요", label: "검토 필요" },
        { key: "완료", label: "완료" },
        { key: "보관", label: "보관" },
    ];

    public projects: any[] = [
        {
            id: "sirius-workroom",
            title: "Sirius Workroom 개편",
            status: "진행 중",
            owner: "김지원",
            summary: "작업물, 프로젝트, 참고자료, 결과물을 한 화면에서 연결하는 개인 작업 공간 개편",
        },
        {
            id: "highschool-credit",
            title: "고교학점제 운영 지원 자료",
            status: "검토 필요",
            owner: "김지원",
            summary: "제안서와 발표자료를 묶은 교육 운영 지원 패키지",
        },
        {
            id: "heritage-proposal",
            title: "국가유산 분류 시각자료",
            status: "완료",
            owner: "김지원",
            summary: "분류체계, 본문 삽입용 시각자료, 참고 렌더 보관",
        },
        {
            id: "monthly-seminar",
            title: "월간 세미나 공유 자료",
            status: "완료",
            owner: "김지원",
            summary: "Season Docs 작업 과정과 산출물을 공유하는 발표자료",
        },
        {
            id: "northeast-culture-history-foundation",
            title: "동북아역사재단",
            status: "초안",
            owner: "김지원",
            summary: "재단 관련 자료와 산출물을 정리하기 위한 프로젝트",
        },
    ];

    private highschoolLegacyPath: string = "/assets/고교학점제/고교학점제 자료";

    private legacyHighschoolResources(): any[] {
        const root = "/assets/고교학점제";
        const legacy = this.highschoolLegacyPath;
        return [
            {
                id: "legacy-highschool-proposal-pdfs",
                type: "output",
                kind: "proposal",
                title: "고교학점제 기존 제안서 PDF",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "제안서", "PDF"],
                summary: "기존 사이트에서 사용하던 고교학점제 제안서 PDF 원본과 0517 버전을 보관",
                description: "새 제안서 초안과 함께 대조할 수 있도록 기존 제안서 PDF 원본 파일을 유지한 마이그레이션 항목입니다.",
                cover: `${root}/proposal-preview.svg`,
                url: `${legacy}/고교학점제 제안서.pdf`,
                connectedIds: ["highschool-proposal", "highschool-presentation"],
                referenceIds: ["legacy-highschool-request", "legacy-highschool-requirements"],
                memo: "원본 PDF와 0517 버전을 함께 남겨 새 구조에서도 기존 제출본을 추적할 수 있게 했다.",
                links: [
                    { label: "제안서 PDF", url: `${legacy}/고교학점제 제안서.pdf` },
                    { label: "제안서 0517", url: `${legacy}/고교학점제 제안서_0517.pdf` },
                    { label: "웹 제안서", url: `${root}/proposal.html` },
                    { label: "편집 원문", url: `${root}/proposal.md` },
                ],
                checklist: [
                    { label: "기존 제목/설명 유지", done: true },
                    { label: "PDF 원본 링크 연결", done: true },
                    { label: "새 제안서 항목과 관계 연결", done: true },
                ],
            },
            {
                id: "legacy-highschool-presentation-pdf",
                type: "output",
                kind: "presentation",
                title: "고교학점제 기존 발표자료 PDF",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "발표자료", "PDF"],
                summary: "기존 사이트에 있던 고교학점제 발표자료 0517 PDF 원본",
                description: "웹 발표자료로 재구성하기 전의 원본 발표자료 PDF를 유지한 보관 항목입니다.",
                cover: `${root}/presentation-preview.svg`,
                url: `${legacy}/고교학점제 발표자료_0517.pdf`,
                connectedIds: ["highschool-presentation", "legacy-highschool-slide-samples"],
                referenceIds: ["legacy-highschool-presentation-design"],
                memo: "기존 PDF 발표본을 새 발표자료 항목과 연결해 비교 가능하게 보관했다.",
                links: [
                    { label: "발표자료 0517 PDF", url: `${legacy}/고교학점제 발표자료_0517.pdf` },
                    { label: "웹 발표자료", url: `${root}/presentation.html` },
                    { label: "발표 구성안", url: `${root}/presentation-outline.md` },
                ],
                checklist: [
                    { label: "발표 PDF 원본 연결", done: true },
                    { label: "웹 발표자료와 관계 연결", done: true },
                    { label: "디자인 지침 연결", done: true },
                ],
            },
            {
                id: "legacy-highschool-request",
                type: "reference",
                kind: "document",
                title: "고교학점제 제안요청서 원본",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "요청서", "PDF"],
                summary: "제안 범위와 요구 맥락을 확인할 수 있는 기존 제안요청서 PDF",
                description: "제안서와 발표자료의 입력 자료로 쓰인 원본 제안요청서입니다.",
                cover: `${legacy}/image2.png`,
                url: `${legacy}/고교학점제 제안요청서.pdf`,
                connectedIds: ["highschool-proposal", "legacy-highschool-proposal-pdfs"],
                referenceIds: [],
                memo: "요청서 원본은 제안서 검토 시 기준 문서로 사용한다.",
                links: [{ label: "제안요청서 PDF", url: `${legacy}/고교학점제 제안요청서.pdf` }],
                checklist: [
                    { label: "요청서 PDF 연결", done: true },
                    { label: "제안서 참고자료 연결", done: true },
                ],
            },
            {
                id: "legacy-highschool-requirements",
                type: "reference",
                kind: "document",
                title: "고교학점제 요구사항 원본",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "요구사항", "HWP"],
                summary: "고교학점제 요구사항 원본 문서의 PDF와 HWP 파일",
                description: "기존 자료 폴더에 있던 요구사항 파일을 PDF/HWP 버튼으로 함께 유지했습니다.",
                cover: `${legacy}/image.png`,
                url: `${legacy}/고교학점제 요구사항.pdf`,
                connectedIds: ["highschool-proposal", "legacy-highschool-request"],
                referenceIds: [],
                memo: "PDF와 HWP 원본을 같이 연결해 기존 파일 접근성을 유지했다.",
                links: [
                    { label: "요구사항 PDF", url: `${legacy}/고교학점제 요구사항.pdf` },
                    { label: "요구사항 HWP", url: `${legacy}/고교학점제 요구사항.hwp` },
                ],
                checklist: [
                    { label: "PDF 링크 연결", done: true },
                    { label: "HWP 링크 연결", done: true },
                ],
            },
            {
                id: "legacy-highschool-writing-guide",
                type: "reference",
                kind: "document",
                title: "고교학점제 작성 요령 원본",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "작성 요령", "HWP"],
                summary: "제안서 작성 기준을 정리한 기존 작성 요령 PDF와 HWP",
                description: "문서 작성 방향과 표현 기준을 확인하기 위한 기존 작성 요령 자료입니다.",
                cover: `${root}/policy-context-card-sample.png`,
                url: `${legacy}/고교학점제 작성 요령.pdf`,
                connectedIds: ["highschool-proposal", "legacy-highschool-presentation-design"],
                referenceIds: [],
                memo: "작성 요령 원본을 보관해 새 제안서 문장 검토 기준으로 연결했다.",
                links: [
                    { label: "작성 요령 PDF", url: `${legacy}/고교학점제 작성 요령.pdf` },
                    { label: "작성 요령 HWP", url: `${legacy}/고교학점제 작성 요령.hwp` },
                ],
                checklist: [
                    { label: "작성 기준 보관", done: true },
                    { label: "PDF/HWP 링크 연결", done: true },
                ],
            },
            {
                id: "legacy-highschool-mobile-captures",
                type: "reference",
                kind: "image",
                title: "고교학점제 모바일 화면 캡처",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "화면 캡처", "이미지"],
                summary: "기존 고교학점제 모바일 화면과 챗봇 UI 캡처 이미지",
                description: "기존 사이트에서 사용하던 모바일 메인 화면, 메뉴, 챗봇 UI 시안을 유지한 이미지 자료입니다.",
                cover: `${legacy}/image2.png`,
                url: `${legacy}/image2.png`,
                connectedIds: ["highschool-presentation", "legacy-highschool-slide-samples"],
                referenceIds: [],
                memo: "기존 화면 톤과 정보 구조를 새 발표자료 시각 레퍼런스로 보관했다.",
                links: [
                    { label: "모바일 메인", url: `${legacy}/image2.png` },
                    { label: "챗봇 화면", url: `${legacy}/image.png` },
                ],
                checklist: [
                    { label: "대표 썸네일 유지", done: true },
                    { label: "캡처 이미지 링크 연결", done: true },
                ],
            },
            {
                id: "legacy-highschool-presentation-design",
                type: "reference",
                kind: "document",
                title: "고교학점제 발표자료 디자인 지침",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-17",
                created: "2026-05-17",
                owner: "김지원",
                tags: ["기존 자료", "디자인", "발표자료"],
                summary: "기존 발표자료 작업에서 확정한 레이아웃, 폰트, 검증 기준",
                description: "발표자료를 수정할 때 적용해야 하는 기존 ReviewOps 디자인 지침 문서입니다.",
                cover: `${root}/presentation-preview.svg`,
                url: `${legacy}/reviewops-presentation-design.md`,
                connectedIds: ["highschool-presentation", "legacy-highschool-writing-guide"],
                referenceIds: [],
                memo: "디자인 기준 문서를 새 자료 구조의 참고자료로 분류했다.",
                links: [{ label: "디자인 지침", url: `${legacy}/reviewops-presentation-design.md` }],
                checklist: [
                    { label: "디자인 지침 연결", done: true },
                    { label: "발표자료와 관계 연결", done: true },
                ],
            },
            {
                id: "legacy-highschool-system-diagrams",
                type: "reference",
                kind: "image",
                title: "고교학점제 운영 도식 자료",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-15",
                created: "2026-05-15",
                owner: "김지원",
                tags: ["기존 자료", "도식", "SVG"],
                summary: "운영 흐름 맵과 회사 조직도 원본 SVG/PNG 시각 자료",
                description: "제안서와 발표자료에 연결되는 운영 흐름 도식, 조직도 이미지, 벡터 원본을 묶어 보관합니다.",
                cover: `${root}/company-org-chart.png`,
                url: `${root}/credit-system-map.svg`,
                connectedIds: ["highschool-proposal", "highschool-presentation"],
                referenceIds: [],
                memo: "이미지와 SVG 원본을 함께 유지해 재사용 가능한 시각 자료로 분류했다.",
                links: [
                    { label: "운영 흐름 SVG", url: `${root}/credit-system-map.svg` },
                    { label: "조직도 PNG", url: `${root}/company-org-chart.png` },
                    { label: "조직도 SVG", url: `${root}/company-org-chart.svg` },
                ],
                checklist: [
                    { label: "도식 파일 연결", done: true },
                    { label: "PNG/SVG 원본 보관", done: true },
                ],
            },
            {
                id: "legacy-highschool-slide-samples",
                type: "reference",
                kind: "image",
                title: "고교학점제 슬라이드 샘플 묶음",
                projectId: "highschool-credit",
                status: "보관",
                progress: 100,
                due: "보관",
                updated: "2026-05-15",
                created: "2026-05-15",
                owner: "김지원",
                tags: ["기존 자료", "슬라이드", "이미지"],
                summary: "정책 배경, 데이터 모델, 역량, 운영 지원, 마무리 가치 슬라이드 샘플",
                description: "발표자료 제작 과정에서 만든 슬라이드별 이미지 샘플을 한 항목으로 묶어 새 갤러리에서 찾을 수 있게 했습니다.",
                cover: `${root}/policy-context-card-sample.png`,
                url: `${root}/policy-context-card-sample.png`,
                connectedIds: ["highschool-presentation", "legacy-highschool-mobile-captures"],
                referenceIds: ["legacy-highschool-presentation-design"],
                memo: "샘플 이미지를 개별 파일 버튼으로 유지해 누락 없이 접근할 수 있다.",
                links: [
                    { label: "정책 배경", url: `${root}/policy-context-card-sample.png` },
                    { label: "정책 배경 Calm", url: `${root}/policy-context-card-sample-calm.png` },
                    { label: "데이터 모델", url: `${root}/data-model-slide-sample.png` },
                    { label: "회사 역량", url: `${root}/company-capability-slide-sample.png` },
                    { label: "운영 지원", url: `${root}/support-operation-slide-sample.png` },
                    { label: "마무리 가치", url: `${root}/closing-value-slide-sample.png` },
                    { label: "ReviewOps 변경 과정", url: `${root}/reviewops-change-process.png` },
                ],
                checklist: [
                    { label: "샘플 이미지 묶음 등록", done: true },
                    { label: "각 이미지 링크 유지", done: true },
                    { label: "디자인 지침 연결", done: true },
                ],
            },
        ];
    }

    private routerSub: any;
    private seedItems: any[] = [
        {
            id: "workroom-database",
            type: "project",
            kind: "document",
            title: "Sirius Workroom 카탈로그 개편",
            projectId: "sirius-workroom",
            status: "진행 중",
            progress: 68,
            due: "이번 주",
            updated: "오늘 09:40",
            created: "2026-05-26",
            owner: "김지원",
            tags: ["대시보드", "데이터베이스", "UX"],
            summary: "작업 상태, 관계, 결과물이 함께 보이는 개인 작업 카탈로그 개편",
            description: "작업물 목록을 프로젝트, 참고자료, 결과물, 체크리스트가 서로 연결되는 문서형 데이터베이스로 정리합니다. 각 항목은 단순 카드가 아니라 연결된 산출물과 메모가 누적되는 작업 페이지로 이어집니다.",
            cover: "/assets/고교학점제/proposal-preview.svg",
            url: "",
            connectedIds: ["highschool-proposal", "monthly-seminar-slides", "heritage-render-reference"],
            referenceIds: ["highschool-notes", "heritage-render-reference"],
            memo: "상세 페이지는 속성, 링크, 관련 자료, 체크리스트가 한 흐름에 쌓이도록 구성한다.",
            links: [],
            checklist: [
                { label: "대시보드 필터와 항목 모델 정리", done: true },
                { label: "작업물 상세 문서 페이지 연결", done: true },
                { label: "상세 페이지에서 관련 자료 재탐색", done: true },
                { label: "실제 데이터 저장 구조 확장", done: false },
            ],
        },
        {
            id: "northeast-history-bigdata-instructions",
            type: "output",
            kind: "document",
            title: "동북아역사재단 역사현안 빅데이터 구축 기능 구조도 및 작업 인스트럭션",
            projectId: "northeast-culture-history-foundation",
            status: "완료",
            progress: 100,
            due: "보관",
            updated: "오늘",
            created: "2026-05-29",
            owner: "김지원",
            tags: ["동북아역사재단", "기능 구조도", "인스트럭션", "태그 체계"],
            summary: "내부 사용을 1차 타깃으로 한 태그 체계, 기능 구조도, 단계별 구현 인스트럭션 문서",
            description: "동북아역사재단 자료 통합, 태그 검수, 지식그래프, 출처 기반 AI 질의응답, 보고서 보조 기능을 구현하기 위한 작업 기준 문서입니다.",
            cover: "",
            url: "/assets/동북아역사재단/동북아역사재단_역사현안_빅데이터_구축_기능구조도_및_작업인스트럭션.md",
            connectedIds: ["workroom-database"],
            referenceIds: [],
            memo: "첨부 피드백과 공식 사업 축을 반영해 내부 1차 구축 기준으로 정리한 문서. 동북아 프로젝트 탭에서 바로 내려받을 수 있게 연결한다.",
            links: [
                {
                    label: "Markdown 다운로드",
                    url: "/assets/동북아역사재단/동북아역사재단_역사현안_빅데이터_구축_기능구조도_및_작업인스트럭션.md",
                    download: "동북아역사재단_역사현안_빅데이터_구축_기능구조도_및_작업인스트럭션.md",
                },
            ],
            checklist: [
                { label: "태그 체계와 공식 사업 축 반영", done: true },
                { label: "기능 구조도와 단계별 MVP 정리", done: true },
                { label: "동북아 프로젝트 다운로드 링크 연결", done: true },
            ],
        },
        {
            id: "highschool-proposal",
            type: "output",
            kind: "proposal",
            title: "고교학점제 운영 지원 제안서",
            projectId: "highschool-credit",
            status: "검토 필요",
            progress: 82,
            due: "5월 15일",
            updated: "오늘 08:20",
            created: "2026-05-15",
            owner: "김지원",
            tags: ["교육", "제안서", "초안"],
            summary: "진로·과목 선택 지원과 학점 이수 관리를 묶은 운영 지원 제안서 초안",
            description: "학생의 진로 선택, 교사의 운영 관리, 학부모 커뮤니케이션을 하나의 운영 지원 흐름으로 묶은 제안서입니다. 발표자료, 참고 메모, 정책 자료와 함께 검토되는 핵심 결과물입니다.",
            cover: "/assets/고교학점제/proposal-preview.svg",
            url: "/assets/고교학점제/proposal.html",
            connectedIds: ["highschool-presentation", "highschool-notes", "workroom-database"],
            referenceIds: ["highschool-notes"],
            memo: "정책 배경, 운영 흐름, 제안 범위를 하나의 제안서 초안으로 매핑했다. 발표자료는 이 제안서의 문제 정의와 기대 효과를 설명하는 보조 결과물이다.",
            links: [
                { label: "제안서", url: "/assets/고교학점제/proposal.html" },
                { label: "원문", url: "/assets/고교학점제/proposal.md" },
                { label: "참고", url: "/assets/고교학점제/reference-notes.md" },
            ],
            checklist: [
                { label: "요구사항과 정책 배경 반영", done: true },
                { label: "운영 흐름 도식 연결", done: true },
                { label: "발표자료와 핵심 메시지 맞춤", done: true },
                { label: "최종 문장 톤 검토", done: false },
            ],
        },
        {
            id: "highschool-presentation",
            type: "output",
            kind: "presentation",
            title: "고교학점제 운영 지원 발표자료",
            projectId: "highschool-credit",
            status: "검토 필요",
            progress: 76,
            due: "5월 15일",
            updated: "어제 18:10",
            created: "2026-05-15",
            owner: "김지원",
            tags: ["교육", "발표자료", "11장"],
            summary: "학생·교사·학부모 흐름을 설명하는 11장 구성의 웹 발표자료",
            description: "제안서의 핵심 문제 정의와 운영 지원 흐름을 발표용 문장과 슬라이드 구조로 재구성한 자료입니다. 제안서와 참고 메모를 오가며 메시지와 시각 자료를 검토합니다.",
            cover: "/assets/고교학점제/presentation-preview.svg",
            url: "/assets/고교학점제/presentation.html",
            connectedIds: ["highschool-proposal", "highschool-notes"],
            referenceIds: ["highschool-notes"],
            memo: "도입부, 전환 슬라이드, 마무리 CTA의 논리 연결을 중점 검토한다.",
            links: [
                { label: "발표자료", url: "/assets/고교학점제/presentation.html" },
                { label: "구성안", url: "/assets/고교학점제/presentation-outline.md" },
            ],
            checklist: [
                { label: "11장 전체 흐름 구성", done: true },
                { label: "제안서와 용어 통일", done: true },
                { label: "시각 자료 배치 점검", done: false },
            ],
        },
        {
            id: "highschool-notes",
            type: "reference",
            kind: "memo",
            title: "고교학점제 정책·운영 참고 메모",
            projectId: "highschool-credit",
            status: "보관",
            progress: 100,
            due: "보관",
            updated: "5월 15일",
            created: "2026-05-15",
            owner: "김지원",
            tags: ["정책", "운영", "메모"],
            summary: "제안서와 발표자료에 연결된 정책·운영 참고 메모",
            description: "고교학점제 제안서와 발표자료에서 공통으로 참조하는 정책, 운영, 작성 방향 메모입니다.",
            cover: "",
            url: "/assets/고교학점제/reference-notes.md",
            connectedIds: ["highschool-proposal", "highschool-presentation"],
            referenceIds: [],
            memo: "제안서와 발표자료의 용어, 운영 흐름, 강조 문장 근거로 사용한다.",
            links: [{ label: "메모", url: "/assets/고교학점제/reference-notes.md" }],
            checklist: [
                { label: "제안서 링크 연결", done: true },
                { label: "발표자료 링크 연결", done: true },
                { label: "최종 보관", done: true },
            ],
        },
        {
            id: "monthly-seminar-slides",
            type: "output",
            kind: "presentation",
            title: "Season Docs 월간 세미나 발표자료",
            projectId: "monthly-seminar",
            status: "완료",
            progress: 100,
            due: "완료",
            updated: "5월 3일",
            created: "2026-05-03",
            owner: "김지원",
            tags: ["세미나", "발표자료", "PDF"],
            summary: "Season Docs 개발 과정과 백석문화대 제안서 작업물을 소개하는 발표자료",
            description: "웹 발표자료, PDF, PPTX 파일을 함께 보관하는 세미나 결과물입니다. 작업 과정과 산출물을 설명하는 내부 공유용 발표 자료로 관리됩니다.",
            cover: "/assets/presentations/monthly-seminar/slide-01.png",
            url: "/assets/presentations/monthly-seminar/index.html",
            connectedIds: ["workroom-database"],
            referenceIds: [],
            memo: "웹, PDF, PPTX를 모두 결과물 첨부로 연결했다.",
            links: [
                { label: "웹", url: "/assets/presentations/monthly-seminar/index.html" },
                { label: "PDF", url: "/assets/presentations/monthly-seminar/monthly-seminar-season-docs-proposal.pdf" },
                { label: "PPTX", url: "/assets/presentations/monthly-seminar/monthly-seminar-season-docs-proposal.pptx" },
            ],
            checklist: [
                { label: "웹 발표자료 생성", done: true },
                { label: "PDF 파일 연결", done: true },
                { label: "PPTX 파일 연결", done: true },
            ],
        },
        {
            id: "heritage-classification-main",
            type: "output",
            kind: "image",
            title: "국가유산 유형분류 제안서 이미지",
            projectId: "heritage-proposal",
            status: "완료",
            progress: 100,
            due: "보관",
            updated: "5월 7일",
            created: "2026-05-07",
            owner: "김지원",
            tags: ["국가유산", "시각 자료", "제안서"],
            summary: "국가유산 유형분류를 제안서 본문에 바로 넣을 수 있도록 정리한 시각 자료",
            description: "국가유산 유형분류 체계를 제안서 본문 삽입에 맞춰 정리한 최종 이미지 결과물입니다. 기본 분류표와 렌더 샘플을 함께 확인합니다.",
            cover: "/assets/proposals/heritage-classification/heritage-type-classification-proposal.png",
            url: "/assets/proposals/heritage-classification/heritage-type-classification-proposal.png",
            connectedIds: ["heritage-classification-basic", "heritage-render-reference"],
            referenceIds: ["heritage-classification-basic", "heritage-render-reference"],
            memo: "제안서 본문 삽입용 최종 이미지 결과물이다.",
            links: [
                { label: "PNG", url: "/assets/proposals/heritage-classification/heritage-type-classification-proposal.png" },
                { label: "SVG", url: "/assets/proposals/heritage-classification/heritage-type-classification-proposal.svg" },
            ],
            checklist: [
                { label: "제안서형 이미지 생성", done: true },
                { label: "기본안과 비교", done: true },
                { label: "렌더 샘플 확인", done: true },
            ],
        },
        {
            id: "heritage-classification-basic",
            type: "reference",
            kind: "image",
            title: "국가유산 유형분류 기본 이미지",
            projectId: "heritage-proposal",
            status: "보관",
            progress: 100,
            due: "보관",
            updated: "5월 7일",
            created: "2026-05-07",
            owner: "김지원",
            tags: ["국가유산", "분류체계", "기본안"],
            summary: "상위 유형과 세부 항목을 한눈에 비교할 수 있게 만든 기본 분류표",
            description: "최종 제안서형 이미지의 기준이 되는 기본 분류표입니다. 분류 항목과 계층 구조를 비교하는 참고자료로 연결됩니다.",
            cover: "/assets/proposals/heritage-classification/heritage-type-classification.png",
            url: "/assets/proposals/heritage-classification/heritage-type-classification.png",
            connectedIds: ["heritage-classification-main", "heritage-render-reference"],
            referenceIds: [],
            memo: "최종 제안서형 이미지의 기준이 되는 기본 분류표다.",
            links: [
                { label: "PNG", url: "/assets/proposals/heritage-classification/heritage-type-classification.png" },
                { label: "SVG", url: "/assets/proposals/heritage-classification/heritage-type-classification.svg" },
            ],
            checklist: [
                { label: "기본 분류 구조 정리", done: true },
                { label: "제안서형 결과물 연결", done: true },
            ],
        },
        {
            id: "heritage-render-reference",
            type: "reference",
            kind: "image",
            title: "국가유산 제안서 렌더 샘플",
            projectId: "heritage-proposal",
            status: "보관",
            progress: 100,
            due: "보관",
            updated: "5월 7일",
            created: "2026-05-07",
            owner: "김지원",
            tags: ["국가유산", "렌더", "페이지 샘플"],
            summary: "제안서 실제 페이지에 들어갔을 때의 밀도와 배치를 확인하기 위한 렌더 샘플",
            description: "시각 자료가 실제 제안서 페이지에 들어갔을 때의 여백, 크기, 밀도를 확인하기 위한 렌더 샘플입니다.",
            cover: "/assets/proposals/heritage-classification/reference-renders/proposal-p03.png",
            url: "/assets/proposals/heritage-classification/reference-renders/proposal-p03.png",
            connectedIds: ["heritage-classification-main", "heritage-classification-basic"],
            referenceIds: [],
            memo: "실제 페이지 렌더에서 이미지 밀도와 여백을 점검한 참고자료다.",
            links: [
                { label: "P03", url: "/assets/proposals/heritage-classification/reference-renders/proposal-p03.png" },
                { label: "P04", url: "/assets/proposals/heritage-classification/reference-renders/proposal-p04.png" },
                { label: "P11", url: "/assets/proposals/heritage-classification/reference-renders/proposal-p11.png" },
                { label: "P21", url: "/assets/proposals/heritage-classification/reference-renders/proposal-p21.png" },
            ],
            checklist: [
                { label: "대표 페이지 렌더 확인", done: true },
                { label: "최종 이미지와 상호 연결", done: true },
            ],
        },
        {
            id: "automation-proposal-draft",
            type: "work",
            kind: "proposal",
            title: "AI 업무 자동화 제안서 초안",
            projectId: "sirius-workroom",
            status: "진행 중",
            progress: 54,
            due: "5월 8일",
            updated: "오늘 11:00",
            created: "2026-05-26",
            owner: "김지원",
            tags: ["자동화", "제안서", "초안"],
            summary: "고객 문제 정의와 자동화 도입 효과를 제안서 초안으로 정리하는 작업",
            description: "고객 문제 정의, 자동화 적용 범위, 기대 효과를 제안서 초안으로 정리하는 진행 중 작업입니다.",
            cover: "",
            url: "",
            connectedIds: ["workroom-database"],
            referenceIds: [],
            memo: "고객 문제 정의와 도입 효과를 먼저 짧은 문장으로 정리한다.",
            links: [],
            checklist: [
                { label: "문제 정의 초안", done: true },
                { label: "자동화 적용 범위 정리", done: false },
                { label: "기대 효과 수치화", done: false },
            ],
        },
        {
            id: "weekly-minutes",
            type: "note",
            kind: "memo",
            title: "운영 주간 회의록 정리",
            projectId: "sirius-workroom",
            status: "검토 필요",
            progress: 72,
            due: "오늘 17:00",
            updated: "오늘 10:30",
            created: "2026-05-26",
            owner: "김지원",
            tags: ["회의록", "액션 아이템", "운영"],
            summary: "결정 사항과 액션 아이템을 공유 가능한 회의록으로 정리",
            description: "결정 사항, 담당자, 후속 액션 아이템을 공유 가능한 회의록으로 정리하는 문서 작업입니다.",
            cover: "",
            url: "",
            connectedIds: ["workroom-database"],
            referenceIds: [],
            memo: "완료 기준이 빠진 항목은 담당자에게 확인 후 보완한다.",
            links: [],
            checklist: [
                { label: "결정 사항 정리", done: true },
                { label: "담당자별 액션 배정", done: true },
                { label: "완료 기준 보완", done: false },
            ],
        },
    ];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.id = this.decodeId(WizRoute.segment.id || "");
    }

    private async renderView() {
        await this.service.sleep(0);
        await this.service.render();
    }

    public async ngOnInit() {
        await this.service.init();
        this.loadStatusOverrides();
        this.loadQuickData();
        await this.loadWorkTasks();
        await this.syncLocalQuickDataToServer();
        this.mergeTaskProjects();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const nextId = this.decodeId(WizRoute.segment.id || "");
                if (nextId !== this.id) {
                    this.id = nextId;
                    await this.load();
                }
            }
        });

        await this.load();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async load() {
        this.item = this.resolveItem(this.id);
        this.missing = !this.item;
        await this.renderView();
    }

    public get allItems(): any[] {
        const sessionItem = this.sessionItem();
        const seedItems = [...this.seedItems, ...this.legacyHighschoolResources()].map((item) => this.normalizeItem(item));
        const seedTitles = seedItems.map((item) => item.title);
        const taskItems = this.taskRows
            .filter((task) => !seedTitles.includes(this.normalizeTitle(task.title || task.result_title || "")))
            .map((task) => this.normalizeItem(this.taskToItem(task)));
        const localItems = this.quickItems
            .filter((item) => !this.isLocalItemBackedByTask(item))
            .filter((item) => !seedTitles.includes(this.normalizeTitle(item.title || "")))
            .map((item) => this.normalizeItem(item));
        const items = [...taskItems, ...localItems, ...seedItems];
        if (!sessionItem) return items;

        const index = items.findIndex((item) => item.id === sessionItem.id);
        if (index < 0) return [this.normalizeItem(sessionItem), ...items];

        const base = items[index];
        items[index] = this.normalizeItem({
            ...base,
            ...sessionItem,
            connectedIds: sessionItem.connectedIds?.length ? sessionItem.connectedIds : base.connectedIds,
            relatedIds: sessionItem.relatedIds?.length ? sessionItem.relatedIds : base.relatedIds,
            referenceIds: sessionItem.referenceIds?.length ? sessionItem.referenceIds : base.referenceIds,
            links: sessionItem.links?.length ? sessionItem.links : base.links,
            attachments: sessionItem.attachments?.length ? sessionItem.attachments : base.attachments,
            checklist: sessionItem.checklist?.length ? sessionItem.checklist : base.checklist,
        });
        return items;
    }

    public get attachments(): any[] {
        if (!this.item) return [];
        const links = this.item.attachments && this.item.attachments.length ? this.item.attachments : this.item.links || [];
        if (this.item.url && !links.some((link: any) => link.url === this.item.url)) {
            return [{ label: "바로 보기", url: this.item.url }, ...links];
        }
        return links;
    }

    public get relatedItems(): any[] {
        if (!this.item) return [];
        const referenceIds = this.item.referenceIds || [];
        const ids = this.item.relatedIds || this.item.connectedIds || [];
        return this.allItems.filter((entry) => ids.includes(entry.id) && !referenceIds.includes(entry.id));
    }

    public get referenceItems(): any[] {
        if (!this.item) return [];
        const ids = this.item.referenceIds || [];
        return this.allItems.filter((entry) => ids.includes(entry.id));
    }

    public get projectSiblings(): any[] {
        if (!this.item) return [];
        return this.allItems
            .filter((entry) => entry.projectId === this.item.projectId && entry.id !== this.item.id)
            .slice(0, 4);
    }

    public get checklist(): any[] {
        if (!this.item) return [];
        return this.item.checklist || [];
    }

    public get doneChecklistCount(): number {
        return this.checklist.filter((entry) => !!entry.done).length;
    }

    public get tagList(): string {
        if (!this.item || !Array.isArray(this.item.tags) || this.item.tags.length === 0) return "-";
        return this.item.tags.map((tag: string) => `#${tag}`).join(", ");
    }

    public get propertyRows(): any[] {
        if (!this.item) return [];
        return [
            { label: "유형", value: `${this.typeLabel(this.item.type)} · ${this.kindLabel(this.item.kind)}` },
            { label: "상태", value: this.item.status },
            { label: "프로젝트", value: this.projectById(this.item.projectId).title },
            { label: "담당", value: this.item.owner || "김지원" },
            { label: "날짜", value: this.item.date || this.item.due || "날짜 미정" },
            { label: "수정", value: this.item.updated || "-" },
            { label: "태그", value: this.tagList },
        ];
    }

    public previewImage(item: any): string {
        return item?.preview || item?.cover || item?.thumbnail || "";
    }

    public previewMode(item: any): string {
        if (!item) return "empty";
        if (this.previewImage(item)) return "image";
        return "file";
    }

    public isMediaFailed(url: string): boolean {
        return !!(url && this.mediaFailures[url]);
    }

    public async markMediaFailed(url: string, event?: Event) {
        if (event) event.stopPropagation();
        if (!url) return;
        this.mediaFailures[url] = true;
        await this.renderView();
    }

    public async retryMedia(url: string, event?: Event) {
        if (event) event.stopPropagation();
        if (!url) return;
        delete this.mediaFailures[url];
        await this.renderView();
    }

    public typeLabel(type: string): string {
        const found = this.contentTypes.find((item) => item.key === type);
        return found ? found.label : "작업물";
    }

    public kindLabel(kind: string): string {
        const normalized = this.normalizeKind(kind || "etc");
        const found = this.kindFilters.find((item) => item.key === normalized);
        return found ? found.label : "기타";
    }

    public projectById(id: string): any {
        return this.projects.find((project) => project.id === id) || this.projects[0];
    }

    public statusTone(status: string): string {
        if (status === "완료") return "border-emerald-200 bg-emerald-50 text-emerald-700";
        if (status === "진행 중") return "border-sky-200 bg-sky-50 text-sky-700";
        if (status === "검토 필요") return "border-violet-200 bg-violet-50 text-violet-700";
        if (status === "보관") return "border-zinc-200 bg-zinc-50 text-zinc-600";
        return "border-amber-200 bg-amber-50 text-amber-700";
    }

    public typeTone(type: string): string {
        if (type === "project") return "bg-zinc-950 text-white";
        if (type === "work") return "bg-sky-100 text-sky-800";
        if (type === "reference") return "bg-amber-100 text-amber-800";
        if (type === "output") return "bg-emerald-100 text-emerald-800";
        if (type === "note") return "bg-violet-100 text-violet-800";
        return "bg-zinc-100 text-zinc-700";
    }

    public async changeStatus(status: string) {
        if (!this.item) return;
        const nextStatus = this.normalizeStatus(status);
        const nextItem = this.normalizeItem({ ...this.item, status: nextStatus, updated: "방금", progress: this.statusProgress(nextStatus) });
        const taskId = nextItem.sourceTaskId || (nextItem.id || "").replace(/^task-/, "");
        if (taskId && this.taskRows.some((row) => `${row.id}` === `${taskId}`)) {
            try {
                const response = await wiz.call("update_task", {
                    id: taskId,
                    data: JSON.stringify(this.taskPayloadFromItem(nextItem)),
                });
                if (response.code === 200 && response.data?.task) {
                    this.replaceTaskRow(response.data.task);
                    this.item = this.resolveItem(this.id) || nextItem;
                    delete this.statusOverrides[nextItem.id];
                    this.saveStatusOverrides();
                } else {
                    this.item = nextItem;
                }
            } catch (e) {
                this.item = nextItem;
            }
        } else {
            this.item = nextItem;
            this.statusOverrides[this.item.id] = nextStatus;
            this.saveStatusOverrides();
        }
        this.storeSessionItem(this.item);
        await this.renderView();
    }

    public canDeleteItem(item: any): boolean {
        if (!item) return false;
        return !!item.sourceTaskId || `${item.id || ""}`.indexOf("local-") === 0;
    }

    public async deleteItem(item: any) {
        if (!this.canDeleteItem(item)) return;
        if (!window.confirm("이 작업물을 삭제할까요?")) return;

        this.deletingItem = true;
        const taskId = item.sourceTaskId || (item.id || "").replace(/^task-/, "");
        try {
            if (taskId && this.taskRows.some((row) => `${row.id}` === `${taskId}`)) {
                const response = await wiz.call("delete_task", { id: taskId });
                if (response.code !== 200) throw new Error(response.data?.message || "삭제에 실패했습니다.");
                this.taskRows = this.taskRows.filter((row) => `${row.id}` !== `${taskId}`);
            } else {
                this.quickItems = this.quickItems.filter((row) => row.id !== item.id);
                this.saveLegacyQuickData();
            }
            sessionStorage.removeItem("workroom-selected-item");
            this.service.href("/dashboard");
        } catch (e) {
            this.deletingItem = false;
            await this.renderView();
        }
    }

    public openItem(item: any) {
        if (!item) return;
        const normalized = this.normalizeItem(item);
        this.storeSessionItem(normalized);
        this.service.href(`/work/${encodeURIComponent(normalized.id)}`);
    }

    public openDashboard() {
        this.service.href("/dashboard");
    }

    private resolveItem(id: string): any {
        if (!id) return null;
        return this.allItems.find((item) => item.id === id) || null;
    }

    private sessionItem(): any {
        try {
            const raw = sessionStorage.getItem("workroom-selected-item") || "";
            if (!raw) return null;
            return JSON.parse(raw);
        } catch (e) {
            return null;
        }
    }

    private storeSessionItem(item: any) {
        try {
            sessionStorage.setItem("workroom-selected-item", JSON.stringify(item));
        } catch (e) {
            return;
        }
    }

    private async loadWorkTasks() {
        try {
            const response = await wiz.call("tasks");
            if (response.code === 200) {
                this.taskRows = response.data.tasks || [];
                this.mergeTaskProjects();
            }
        } catch (e) {
            this.taskRows = [];
        }
    }

    private loadQuickData() {
        try {
            const projects = JSON.parse(localStorage.getItem("workroom-quick-projects") || "[]");
            const items = JSON.parse(localStorage.getItem("workroom-quick-items") || "[]");
            if (Array.isArray(projects)) {
                this.localQuickProjects = projects
                    .filter((project: any) => !!project?.id)
                    .map((project: any) => ({ ...project, title: this.normalizeProjectTitle(project.title) }));
                this.localQuickProjects.slice().reverse().forEach((project: any) => {
                    if (project?.id && !this.projects.some((row) => row.id === project.id)) {
                        this.projects = [project, ...this.projects];
                    }
                });
            }
            if (Array.isArray(items)) {
                const knownIds = this.seedItems.map((item) => item.id);
                this.quickItems = items.filter((item: any) => item?.id && !knownIds.includes(item.id));
            }
        } catch (e) {
            this.quickItems = [];
            this.localQuickProjects = [];
        }
    }

    private saveLegacyQuickData() {
        try {
            localStorage.setItem("workroom-quick-projects", JSON.stringify(this.localQuickProjects));
            localStorage.setItem("workroom-quick-items", JSON.stringify(this.quickItems));
        } catch (e) {
            return;
        }
    }

    private findTaskForLocalItem(item: any): any {
        if (item.sourceTaskId) {
            const bySource = this.taskRows.find((task) => `${task.id}` === `${item.sourceTaskId}`);
            if (bySource) return bySource;
        }
        return this.taskRows.find((task) => this.normalizeTitle(task.title || task.result_title || "") === this.normalizeTitle(item.title || "") && this.normalizeKind(task.kind) === this.normalizeKind(item.kind));
    }

    private isLocalItemBackedByTask(item: any): boolean {
        return !!this.findTaskForLocalItem(item);
    }

    private async syncLocalQuickDataToServer() {
        if (!this.quickItems.length) return;
        const migratedIds: string[] = [];

        for (const localItem of this.quickItems) {
            const normalized = this.normalizeItem(localItem);
            const existing = this.findTaskForLocalItem(normalized);
            const payload = this.taskPayloadFromItem(normalized);
            try {
                const response = existing
                    ? await wiz.call("update_task", { id: existing.id, data: JSON.stringify(payload) })
                    : await wiz.call("create_task", { data: JSON.stringify(payload) });
                if (response.code === 200 && response.data?.task) {
                    this.replaceTaskRow(response.data.task);
                    migratedIds.push(localItem.id);
                }
            } catch (e) {
                continue;
            }
        }

        if (migratedIds.length) {
            this.quickItems = this.quickItems.filter((item) => !migratedIds.includes(item.id));
            this.saveLegacyQuickData();
        }
    }

    private replaceTaskRow(task: any) {
        if (!task?.id) return;
        const index = this.taskRows.findIndex((row) => `${row.id}` === `${task.id}`);
        if (index >= 0) {
            this.taskRows = this.taskRows.map((row, rowIndex) => rowIndex === index ? task : row);
        } else {
            this.taskRows = [task, ...this.taskRows];
        }
    }

    private mergeTaskProjects() {
        const next = [...this.projects];
        const upsert = (project: any) => {
            if (!project?.id || !project?.title) return;
            if (next.some((row) => row.id === project.id)) return;
            next.unshift(project);
        };

        this.localQuickProjects.forEach((project) => upsert(project));
        this.taskRows.forEach((task) => {
            const type = task.type || task.itemType || task.item_type || "";
            const taskProjectId = task.projectId || task.project_id || (type === "project" ? `task-${task.id}` : "");
            const taskProjectTitle = this.normalizeProjectTitle(task.projectName || task.project_title || task.audience || (type === "project" ? task.title : ""));
            upsert({
                id: taskProjectId,
                title: taskProjectTitle,
                status: task.status || "진행 중",
                owner: task.owner || "김지원",
                summary: task.summary || task.purpose || "",
            });
        });

        this.projects = next;
    }

    private loadStatusOverrides() {
        try {
            this.statusOverrides = JSON.parse(localStorage.getItem("workroom-status-overrides") || "{}");
        } catch (e) {
            this.statusOverrides = {};
        }
    }

    private saveStatusOverrides() {
        try {
            localStorage.setItem("workroom-status-overrides", JSON.stringify(this.statusOverrides));
        } catch (e) {
            return;
        }
    }

    private taskToItem(task: any): any {
        const kind = this.normalizeKind(task.kind || "etc");
        const status = this.normalizeStatus(task.status || "초안");
        const type = task.type || task.itemType || task.item_type || (task.result_title || task.result_summary || task.result_url ? "output" : "work");
        const taskItemId = `task-${task.id}`;
        const projectId = task.projectId || task.project_id || (type === "project" ? taskItemId : this.projects[0]?.id);
        const project = this.projectById(projectId);
        const projectName = this.normalizeProjectTitle(task.projectName || task.project_title || task.audience || project.title);
        const summary = task.summary || task.result_summary || task.purpose || "목적을 보완해 주세요.";
        const description = task.description || summary;
        const url = task.url || task.result_url || "";
        const links = Array.isArray(task.links) && task.links.length ? task.links : (url ? [{ label: task.result_title || "바로 보기", url }] : []);
        const attachments = Array.isArray(task.attachments) && task.attachments.length ? task.attachments : links;
        const tags = Array.isArray(task.tags) && task.tags.length ? task.tags : [this.kindLabel(kind), "요청"].filter((tag) => !!tag);
        return {
            id: taskItemId,
            sourceTaskId: task.id,
            type,
            kind,
            title: task.title || task.result_title,
            projectId,
            projectName,
            status,
            progress: typeof task.progress === "number" ? task.progress : this.statusProgress(status),
            date: task.date || task.date_label || task.due || task.updatedText || task.createdText || "날짜 미정",
            due: task.due || "날짜 미정",
            updated: task.updatedText || task.createdText || "최근",
            created: task.createdText || task.updatedText || "",
            owner: task.owner || "김지원",
            tags: this.normalizeTags(tags, type, kind),
            description,
            summary,
            thumbnail: task.thumbnail || task.cover || "",
            cover: task.cover || task.thumbnail || "",
            url,
            relatedIds: task.relatedIds || task.related_ids || [],
            connectedIds: task.connectedIds || task.connected_ids || [],
            referenceIds: task.referenceIds || task.reference_ids || [],
            attachments,
            links,
            memo: task.memo || task.reference || "",
            checklist: task.checklist || [],
            kindLabel: this.kindLabel(kind),
            typeLabel: this.typeLabel(type),
        };
    }

    private taskPayloadFromItem(item: any): any {
        const project = this.projectById(item.projectId);
        const links = item.links && item.links.length ? item.links : (item.attachments || []);
        const attachments = item.attachments && item.attachments.length ? item.attachments : links;
        const summary = item.summary || item.description || "";
        return {
            type: item.type || "work",
            kind: item.kind || "etc",
            title: item.title || "",
            status: item.status || "초안",
            purpose: summary,
            audience: item.projectName || project.title,
            due: item.due || item.date || "",
            reference: item.reference || item.memo || "",
            result_title: item.type === "output" ? item.title || "" : item.result_title || "",
            result_url: item.type === "output" ? item.url || "" : item.result_url || "",
            result_summary: item.type === "output" ? summary : item.result_summary || "",
            project_id: item.projectId || project.id,
            project_title: item.projectName || project.title,
            owner: item.owner || "김지원",
            tags: item.tags || [],
            description: item.description || summary,
            summary,
            cover: item.cover || "",
            thumbnail: item.thumbnail || item.cover || "",
            url: item.url || "",
            links,
            attachments,
            memo: item.memo || "",
            checklist: item.checklist || [],
            related_ids: item.relatedIds || [],
            connected_ids: item.connectedIds || [],
            reference_ids: item.referenceIds || [],
            progress: typeof item.progress === "number" ? item.progress : this.statusProgress(item.status || "초안"),
            date: item.date || item.due || "",
        };
    }

    private normalizeStatus(status: string): string {
        status = `${status || ""}`.trim();
        if (status === "초안" || status === "아이디어" || status === "요청됨") return "초안";
        if (["완료", "완성본"].includes(status)) return "완료";
        if (status === "공유 대기") return "검토 필요";
        if (["작성 중", "진행 중"].includes(status)) return "진행 중";
        if (status.indexOf("검토") >= 0) return "검토 필요";
        if (status === "보관" || status === "보관본" || status === "아카이브") return "보관";
        return "초안";
    }

    private normalizeKind(kind: string): string {
        if (kind === "minutes") return "document";
        if (this.kindFilters.some((item) => item.key === kind)) return kind;
        return "etc";
    }

    private normalizeItem(item: any): any {
        const localStatus = item.sourceTaskId ? "" : this.statusOverrides[item.id];
        const type = item.type || "work";
        const kind = this.normalizeKind(item.kind || "etc");
        const project = this.projectById(item.projectId);
        let status = this.normalizeStatus(localStatus || item.status || "초안");
        if (type === "reference" && status === "완료") status = "보관";
        const links = item.links && item.links.length ? item.links : (item.attachments || []);
        const attachments = item.attachments && item.attachments.length ? item.attachments : links;
        const thumbnail = item.thumbnail || item.cover || "";
        const relatedIds = item.relatedIds || item.connectedIds || [];
        const summary = item.summary || item.description || this.defaultItemSummary(item, type, kind, project);
        const description = item.description || summary;
        const tags = this.normalizeTags(item.tags || [], type, kind);
        const date = this.normalizedDate(item, status);
        const checklist = item.checklist || this.defaultChecklist({ ...item, summary, description, tags }, status);

        return {
            ...item,
            title: this.normalizeTitle(item.title || ""),
            type,
            kind,
            status,
            progress: typeof item.progress === "number" ? item.progress : this.statusProgress(status),
            projectName: this.normalizeProjectTitle(item.projectName || project.title),
            description,
            summary,
            date,
            due: item.due || item.date || date,
            tags,
            thumbnail,
            cover: thumbnail,
            attachments,
            links,
            relatedIds,
            connectedIds: relatedIds,
            referenceIds: item.referenceIds || [],
            memo: item.memo || item.note || "",
            checklist,
            kindLabel: this.kindLabel(kind),
            typeLabel: this.typeLabel(type),
        };
    }

    private normalizeProjectTitle(title: string): string {
        const aliases: any = {
            "개인 작업물 데이터베이스": "Sirius Workroom 개편",
            "고교학점제 운영 지원": "고교학점제 운영 지원 자료",
            "국가유산 제안서 패키지": "국가유산 분류 시각자료",
            "월간 세미나 발표": "월간 세미나 공유 자료",
        };
        const value = `${title || ""}`.trim();
        return aliases[value] || value;
    }

    private normalizeTitle(title: string): string {
        const aliases: any = {
            "개인 작업물 데이터베이스 개편": "Sirius Workroom 카탈로그 개편",
            "고교학점제 제안서": "고교학점제 운영 지원 제안서",
            "고교학점제 발표자료": "고교학점제 운영 지원 발표자료",
            "고교학점제 참고 메모": "고교학점제 정책·운영 참고 메모",
            "월간 세미나 발표자료": "Season Docs 월간 세미나 발표자료",
            "국가유산 유형분류 제안서형": "국가유산 유형분류 제안서 이미지",
            "국가유산 유형분류 기본안": "국가유산 유형분류 기본 이미지",
            "국가유산 제안서 페이지 샘플": "국가유산 제안서 렌더 샘플",
            "AI 업무 자동화 제안서": "AI 업무 자동화 제안서 초안",
            "운영 주간 회의록": "운영 주간 회의록 정리",
            "고교학점제 제안서 원본 PDF": "고교학점제 기존 제안서 PDF",
            "고교학점제 발표자료 원본 PDF": "고교학점제 기존 발표자료 PDF",
            "고교학점제 제안요청서": "고교학점제 제안요청서 원본",
            "고교학점제 요구사항": "고교학점제 요구사항 원본",
            "고교학점제 작성 요령": "고교학점제 작성 요령 원본",
        };
        const value = `${title || ""}`.trim();
        return aliases[value] || value;
    }

    private normalizeTags(tags: any[], type: string = "", kind: string = ""): string[] {
        const aliases: any = {
            "발표자료 작성": "발표자료",
            "제안서 작성": "제안서",
            "문서 작성": "문서",
            "이미지 작업": "이미지",
            "링크 정리": "링크",
            "메모 작성": "메모",
            "기타 작업": "기타",
            "기존자료": "기존 자료",
            "시각자료": "시각 자료",
            "작성요령": "작성 요령",
            "화면캡처": "화면 캡처",
            "액션아이템": "액션 아이템",
            "pdf": "PDF",
            "hwp": "HWP",
            "svg": "SVG",
            "ux": "UX",
        };
        return (tags || [])
            .map((tag) => `${tag || ""}`.trim())
            .filter((tag) => !!tag)
            .map((tag) => aliases[tag] || aliases[tag.toLowerCase()] || tag)
            .filter((tag, index, rows) => rows.indexOf(tag) === index)
            .filter((tag) => !(type === "reference" && tag === "참고자료"))
            .filter((tag) => !(kind && tag === `${this.kindLabel(kind)} 작성`));
    }

    private normalizedDate(item: any, status: string): string {
        const value = item.date || item.due || "";
        if (value && !["완료", "보관"].includes(value)) return value;
        return item.updated || item.created || item.createdText || item.updatedText || (status === "보관" ? "보관" : "날짜 미정");
    }

    private defaultItemSummary(item: any, type: string, kind: string, project: any): string {
        const projectTitle = this.normalizeProjectTitle(project?.title || item.projectName || "프로젝트");
        return `${projectTitle}에 연결된 ${this.kindLabel(kind)} ${this.typeLabel(type)}입니다.`;
    }

    private defaultChecklist(item: any, status: string): any[] {
        const hasAttachment = !!(item.url || (item.links && item.links.length) || (item.attachments && item.attachments.length));
        const hasRelation = !!((item.relatedIds && item.relatedIds.length) || (item.connectedIds && item.connectedIds.length) || (item.referenceIds && item.referenceIds.length));
        return [
            { label: "제목/설명", done: !!(item.title && (item.summary || item.description)) },
            { label: "프로젝트/태그", done: !!(item.projectId && item.tags && item.tags.length) },
            { label: "첨부/관계", done: hasAttachment || hasRelation || status === "완료" || status === "보관" },
        ];
    }

    private statusProgress(status: string): number {
        if (status === "완료") return 100;
        if (status === "검토 필요") return 75;
        if (status === "진행 중") return 48;
        if (status === "보관") return 100;
        return 10;
    }

    private decodeId(id: string): string {
        try {
            return decodeURIComponent(id || "");
        } catch (e) {
            return id || "";
        }
    }
}

export default PageWorkItemComponent;